import MyMap from "components/Common/google-map/MyMap";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Col, Row } from "reactstrap";

const SummaryPage = ({
	setModal,
	id,
	goBackHandler,
	data,
	createResale,
	inputLang,
}) => {
	const location = useLocation();
	const { t } = useTranslation();
	const [formData, setFormData] = useState({ ...data });

	return (
		<>
			<Row className="mt-4 pb-2 px-0 box-container ">
				<Col
					md={12}
					className="py-2 mb-4 text-primary"
					style={{ background: "var(--primary-color)", borderRadius: "15px" }}>
					<h5 className="m-0 py-1" style={{ color: "#fff" }}>
						Property Details
					</h5>
				</Col>
				<Col md={4} className="mb-4 text-primary">
					<p className="mb-1">Unit Type</p>
					<h5>
						{!!formData?.propertType?.en
							? formData?.propertType[inputLang]
							: ""}
					</h5>
				</Col>
				{formData?.in_compound && (
					<Col md={4} className="mb-4">
						<p className="mb-1 text-primary">Compound Name</p>
						<h5>{formData?.selectedCompound?.label}</h5>
					</Col>
				)}
				<Col md={4} className="mb-4">
					<p className="mb-1 text-primary">Name</p>
					<h5>{formData[inputLang]}</h5>
				</Col>
				{(!!formData?.descrip_en ||
					!!formData?.descrip_ar ||
					!!formData?.descrip_ru ||
					!!formData?.descrip_zh) && (
					<Col md={4} className="mb-4">
						<p className="mb-1 text-primary">Description</p>
						{!!formData?.descrip_en && inputLang == "en" && (
							<h5>{formData?.descrip_en}</h5>
						)}
						{!!formData?.descrip_ar && inputLang == "ar" && (
							<h5>{formData?.descrip_ar}</h5>
						)}
						{!!formData?.descrip_ru && inputLang == "ru" && (
							<h5>{formData?.descrip_ru}</h5>
						)}
						{!!formData?.descrip_zh && inputLang == "zh" && (
							<h5>{formData?.descrip_zh}</h5>
						)}
					</Col>
				)}
				<Col md={4} className="mb-4">
					<p className="mb-1 text-primary">Facing</p>
					<h5>{formData?.facing?.label}</h5>
				</Col>
				<Col md={4} className="mb-4">
					<p className="mb-1 text-primary">Finishing</p>
					<h5>{formData?.selectedFinishingType?.label}</h5>
				</Col>
				<Col md={4} className="mb-4">
					<p className="mb-1 text-primary">Furnishing</p>
					<h5>{formData?.furnishing?.label}</h5>
				</Col>
				<Col md={4} className="mb-4">
					<p className="mb-1 text-primary">No. of Bedrooms</p>
					<h5>{formData?.bedrooms}</h5>
				</Col>
				<Col md={4} className="mb-4">
					<p className="mb-1 text-primary">No. of Bathrooms</p>
					<h5>{formData?.bathrooms}</h5>
				</Col>

				{!!formData?.total_land_area ? (
					<>
						<Col md={4} className="mb-4">
							<p className="mb-1 text-primary">Build Up Area</p>
							<h5>{formData?.total_built_up_area}</h5>
						</Col>
						<Col md={4} className="mb-4">
							<p className="mb-1 text-primary">Total Land Area</p>
							<h5>{formData?.total_land_area}</h5>
						</Col>
						<Col md={4} className="mb-4">
							<p className="mb-1 text-primary">Number of Floors</p>
							<h5>{formData?.floor}</h5>
						</Col>
					</>
				) : (
					<>
						<Col md={4} className="mb-4">
							<p className="mb-1 text-primary">Total Build Up Area</p>
							<h5>{formData?.total_built_up_area}</h5>
						</Col>
						<Col md={4} className="mb-4">
							<p className="mb-1 text-primary">Floor Number</p>
							<h5>{formData?.floor}</h5>
						</Col>
					</>
				)}
				{formData?.amenities?.length !== 0 && (
					<Col md={12} className="mb-4">
						<p className="mb-1 text-primary">Amenities</p>
						<ul style={{ display: "flex", gap: "50px", padding: "inherit" }}>
							{formData?.amenities?.map((item, index) => {
								if (item.label !== "Other") {
									return (
										<li key={index}>
											<h5>{item?.label}</h5>
										</li>
									);
								} else {
									return (
										<li key={index}>
											<h5>{formData?.amenitiesOther?.label}</h5>
										</li>
									);
								}
							})}
						</ul>
					</Col>
				)}

				{/* ----------------------------- Location Div ----------------------------- */}
				<Col
					md={12}
					className="py-2 mb-4 text-primary"
					style={{ background: "var(--primary-color)", borderRadius: "15px" }}>
					<h5 className="m-0 py-1" style={{ color: "#fff" }}>
						Location
					</h5>
				</Col>
				<Col md={4} className="mb-4">
					<p className="mb-1 text-primary">Governorate</p>
					<h5>{formData?.governorate?.label}</h5>
				</Col>
				<Col md={4} className="mb-4">
					<p className="mb-1 text-primary">City</p>
					<h5>{formData?.selectedCity?.label}</h5>
				</Col>
				<Col md={4} className="mb-4">
					<p className="mb-1 text-primary">Location</p>
					<h5>{formData?.area?.label}</h5>
				</Col>
				<Col md={4} className="mb-4">
					<p className="mb-1 text-primary">Street Address</p>
					<h5>{formData?.street_address[inputLang]}</h5>
				</Col>
				{formData?.showMap && (
					<Col md={12} className="mb-4">
						<p className="mb-1 text-primary">Location on Map</p>
						<MyMap
							draggable={false}
							lat={formData?.lat}
							lng={formData?.lang}
							onMouseOut={false}
						/>
					</Col>
				)}

				{/* ----------------------------- Payment Div ----------------------------- */}
				<Col
					md={12}
					className="py-2 mb-4 text-primary"
					style={{ background: "var(--primary-color)", borderRadius: "15px" }}>
					<h5 className="m-0 py-1" style={{ color: "#fff" }}>
						Payment
					</h5>
				</Col>
				<Col md={4} className="mb-4">
					<p className="mb-1 text-primary">Depost</p>
					<h5>{toCurrency(formData?.depost)} LE</h5>
				</Col>
				<Col md={4} className="mb-4">
					<p className="mb-1 text-primary">{t("Total Price")}</p>
					<h5>{toCurrency(formData?.total_price)} LE</h5>
				</Col>
				<Col md={4} className="mb-4">
					<p className="mb-1 text-primary">Payment Method</p>
					{formData?.payment_method === "Cash" && <h5>Cash</h5>}
					{formData?.payment_method === "Installment" && (
						<h5>Installment with Seller</h5>
					)}
					{formData?.payment_method === "Owner Installment" && (
						<h5>Rest of Installment with Compound</h5>
					)}
				</Col>

				{formData?.payment_method === "Installment" && (
					<Row>
						<Col md={4} className="mb-4">
							<p className="mb-1 text-primary">{t("Down Payment")}</p>
							<h5>{toCurrency(formData?.down_payment)} LE</h5>
						</Col>
						<Col md={4} className="mb-4">
							<p className="mb-1 text-primary">{t("Years")}</p>
							<h5>{formData?.years}</h5>
						</Col>
						<Col md={4} className="mb-4">
							<p className="mb-1 text-primary">{t("Payment Frequency")}</p>
							<h5>{formData?.payment_frequency.label}</h5>
						</Col>
					</Row>
				)}

				{formData?.payment_method === "Owner Installment" && (
					<Row>
						{!!formData?.original_price && (
							<Col md={4} className="mb-4">
								<p className="mb-1 text-primary">{t("Origin Price")}</p>
								<h5>{toCurrency(formData?.original_price)} LE</h5>
							</Col>
						)}
						<Col md={4} className="mb-4">
							<p className="mb-1 text-primary">Remaining Price</p>
							<h5>{toCurrency(formData?.remaining_price)} LE</h5>
						</Col>
						<Col md={4} className="mb-4">
							<p className="mb-1 text-primary">{t("Payment Frequency")}</p>
							<h5>{formData?.payment_frequency.label}</h5>
						</Col>
						<Col md={4} className="mb-4">
							<p className="mb-1 text-primary">
								{formData?.payment_frequency?.label === "One Shot"
									? t("Month")
									: t("Until Month")}
							</p>
							<h5>{formData?.until_month}</h5>
						</Col>
						<Col md={4} className="mb-4">
							<p className="mb-1 text-primary">
								{formData?.payment_frequency?.label === "One Shot"
									? t("Year")
									: t("Until Year")}
							</p>
							<h5>{formData?.until_year}</h5>
						</Col>
						{!!formData?.off_payments && formData?.off_payments.length > 0 && (
							<Row className="mb-4">
								<p className="mb-1 text-primary">Another Payment Plan:</p>
								{formData?.off_payments?.map((item, index) => {
									return (
										<Row
											key={index}
											className="mx-3 my-2 px-1 pt-3 box-container">
											<Col md={4} className="mb-4">
												<p className="mb-1 text-primary">{t("Payment Name")}</p>
												<h5>{item?.payment_name}</h5>
											</Col>
											<Col md={4} className="mb-4">
												<p className="mb-1 text-primary">{t("Payment Fees")}</p>
												<h5>{toCurrency(item?.payment_fees)} LE</h5>
											</Col>
											<Col md={4} className="mb-4">
												<p className="mb-1 text-primary">
													{t("Payment Frequency")}
												</p>
												<h5>{item?.payment_frequency}</h5>
											</Col>
											<Col md={4} className="mb-4">
												<p className="mb-1 text-primary">
													{item?.payment_frequency === "One Shot"
														? t("Month")
														: t("Start Month")}
												</p>
												<h5>{item?.month_number}</h5>
											</Col>
											<Col md={4} className="mb-4">
												<p className="mb-1 text-primary">
													{item?.payment_frequency === "One Shot"
														? t("Year")
														: t("Start Year")}
												</p>
												<h5>{item?.year_number}</h5>
											</Col>
											{item?.payment_frequency !== "One Shot" && (
												<Col md={4} className="mb-4">
													<p className="mb-1 text-primary">{t("End Month")}</p>
													<h5>{item?.end_month}</h5>
												</Col>
											)}
											{item?.payment_frequency !== "One Shot" && (
												<Col md={4} className="mb-4">
													<p className="mb-1 text-primary">{t("End Year")}</p>
													<h5>{item?.end_year}</h5>
												</Col>
											)}
										</Row>
									);
								})}
							</Row>
						)}
					</Row>
				)}

				{/* ----------------------------- Bank Account ----------------------------- */}
				{(!!formData?.iban ||
					!!formData?.swift ||
					!!formData?.bank_account) && (
					<Col
						md={12}
						className="py-2 mb-4 text-primary"
						style={{
							background: "var(--primary-color)",
							borderRadius: "15px",
						}}>
						<h5 className="m-0 py-1" style={{ color: "#fff" }}>
							Back Account Information
						</h5>
					</Col>
				)}
				{!!formData?.swift && (
					<Col md={6} className="mb-4">
						<p className="mb-1 text-primary">{t("Swift Code")}</p>
						<h5>{formData?.swift}</h5>
					</Col>
				)}
				{!!formData?.iban && (
					<Col md={6} className="mb-4">
						<p className="mb-1 text-primary">{t("IBAN No.")}</p>
						<h5>{formData?.iban}</h5>
					</Col>
				)}
				{!!formData?.bank_account && (
					<Col md={6} className="mb-4">
						<p className="mb-1 text-primary">{t("Account Number")}</p>
						<h5>{formData?.bank_account}</h5>
					</Col>
				)}
			</Row>
			<Row className="my-4">
				<Col md={9}>
					<button
						type="button"
						style={{ borderRadius: "5px", width: "15%" }}
						className="btn btn-light btnHeight cancel text-center "
						onClick={() => setModal(true)}>
						{t("Cancel")}
					</button>
				</Col>
				<Col md={3} className="d-flex justify-content-between">
					<button
						type="button"
						onClick={goBackHandler}
						className="btn btn-light btnHeight back text-center"
						style={{ borderRadius: "5px", width: "45%" }}>
						{t("Back")}
					</button>
					<button
						onClick={() => createResale()}
						style={{
							borderRadius: "5px",
							width: "45%",
							borderColor: "var(--primary-color)",
							background: "var(--primary-color)",
						}}
						className="btn btn-success btnHeight next text-center">
						{t("Submit")}
					</button>
				</Col>
			</Row>
		</>
	);
};

const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};
export default SummaryPage;
